module.exports = __webpack_public_path__ + "img/bsc-scan.f7937c96.png";